import * as Yup from "yup";

export const formValidationAddress = Yup.object().shape({
    country_id: Yup.string().required("Country is required !"),
    province_id: Yup.string().required("Province is required !"),
    regency_id: Yup.string().required("Regency is required !"),
    subdistrict_id: Yup.string().required("Subdistrict is required !"),
    village_id: Yup.string().required("Village is required !")
});
